import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  baseFastApiMedicalTreatmentRoute,
  baseFastApiMatterRoute,
} from "@/lib/data/requests/matters/matter";
import { serializeMedicalTreatmentPlanPayload } from "@/lib/data/requests/matters/medical-treatment-payloads";
import type {
  APIResponse,
  MedicalTreatmentPlan,
  SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMedicalTreatmentPlanV3 = (
  data: Pick<MedicalTreatmentPlan, "matterId"> &
    Partial<Omit<MedicalTreatmentPlan, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MedicalTreatmentPlan>>(
      "matters/v4/medical-treatments/plans",
      {
        ...serializeMedicalTreatmentPlanPayload(data),
        connections: data.connections ?? [],
      },
    )
    .then((res) => res.data);
};

export const updateMedicalTreatmentPlanV1 = (
  data: Pick<MedicalTreatmentPlan, "id" | "dateModified"> &
    Partial<MedicalTreatmentPlan>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MedicalTreatmentPlan>
    >(`${baseFastApiMedicalTreatmentRoute}/plans`, serializeMedicalTreatmentPlanPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentPlanV1 = (
  data: Pick<MedicalTreatmentPlan, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatmentPlan>
    >(`${baseFastApiMatterRoute}/medical-treatments/plans/${id}`)
    .then((res) => res.data);
};
